import { Editor } from "slate";
import { isMarkActive } from "./isMarkActive";
export var toggleMark = function (editor, format, value) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        Editor.removeMark(editor, format);
    }
    else {
        if (value) {
            Editor.removeMark(editor, format);
            Editor.addMark(editor, format, value);
        }
        else {
            Editor.addMark(editor, format, true);
        }
    }
};
